import {chain} from "../../utils/fs";
import {changeNestedValue} from "../../utils/arr-path";
import {omit} from "../../utils/objects";
import {toCopayFormReq} from "./to-copay-form-req";

export const createCopayForm = (input) => chain(
    input,
    parseMls,
    extractField("streetAddress"),
    extractField("zip", {rejectKey:(key) => isNaN(key)}),
    copayAdjustment,
    parseRemainingFields,
    (_) => ({
        fields: _.ret,
        toReq: (data) => toCopayFormReq(data, _.ret),
    }),
);

const parseMls = (input) => {
    if (!input.copay.fields?.mls) {
        return input;
    }

    const key = "mls";
    return chain(
        input,
        (_) => changeNestedValue(_, ["copay", "fields"], (_) => omit(_, [key, "mlsBypass"])),
        (_) => changeNestedValue(_, ["ret"], (_) => [
            ..._ ?? [],
            {
                label: input.copay.fields[key].label,
                path: key,

                ...input.copay.bypassOption && {
                    bypassField: "mlsBypass",
                    bypassLabel: "No MLS number available",
                },
            },
        ]),
    );
};

function extractField1(input, key, options=undefined) {
    return chain(
        input,
        (_) => changeNestedValue(_, ["copay", "fields"], (_) => omit(_, [key])),
        (_) => changeNestedValue(_, ["ret"], (_) => [
            ..._ ?? [],
            {
                ...options,
                label: input.copay.fields[key].label,
                path: key,
            },
        ]),
    );
}

const extractField = (key, options=undefined) => (input) => {
    if (!input.copay?.fields || !input.copay.fields[key]) {
        return input;
    }
    return extractField1(input, key, options);
};

const copayAdjustment = (input) => {
    const key = "copayAdjustment";
    if (!input.copay?.fields || !input.copay.fields[key] || !input.applied) {
        return changeNestedValue(input, ["copay", "fields"], (_) => omit(_, [key]));
    }
    return extractField1(input, key, {
        rejectKey: (key) => isNaN(key) && key !== ".",
    });
};

const parseRemainingFields = (input) => {
    if (!input.copay?.fields) {
        return input;
    }
    return chain(
        input,
        ...Object.keys(input.copay?.fields).map((key) => (
            (_) => extractField1(_, key)
        )),
    );
};


